<vc-chart-wrapper [loading]="loading">
    <h2 chartActionsTitle class="h3-heading">{{ 'TIMELINE.CHART.TITLE_TIMELINE' | transloco }}</h2>
    @if (showTimeIntervalSelector) {
        <vc-select
            chartActionsRightSide
            [label]="'COMMON_UI.SELECT.TIME_FRAME' | transloco"
            [minimalStyles]="true"
            [(value)]="selectedTime"
            (valueChange)="onTimeIntervalChange($event)"
            [options]="times"
            [itemRenderer]="timeIntervalItemRenderer"></vc-select>
    }
    <highcharts-chart
        [options]="chartOptions"
        (chartInstance)="chartCallback($event)"
        class="timeline-chart no-title"></highcharts-chart>
</vc-chart-wrapper>
